<div class="rev-custom-tooltip-content">
	<pms-patient-popover [patientName]="patientName"></pms-patient-popover>
</div>
